import angular from 'angular';
import template from './kform-builder-component.html';

const kformBuilderComponentDirective = /* @ngInject */ (/** @type {any} */ kformComponentDirective) => {
	return angular.extend(
		{},
		kformComponentDirective[0],
		{
			scope: false,
			template,
		},
	);
}

export default kformBuilderComponentDirective;
